export function dialog_dispatch(state = {}, action) {
  if (action.type === 'SHOW_DIALOG_DISPATCH') {
    return action.alert;
  }
  if (action.type === 'CLOSE_DIALOG_DISPATCH') {
    return action.alert;
  }
  return state;
}
